import { useEffect, useState } from "react";
import { sessionService } from "redux-react-session";

export const useSession = () => {
  const [session, setSession] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSession = async () => {
      setLoading(true);
      try {
        const res = await sessionService.loadSession();

        setSession(res);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadSession();
  }, []);
  return { session, loading, error };
};
